<template>
  <div>
    <div id="myAccount">
      <el-main :userData="userData">
        <div style="margin-top:40px;">
          <div>
            <span class="cooperation">Business</span>
            <span class="cooperation">{{ $t('myAccount.header.cooperation') }}</span>
          </div>
          <div class="accountHeaderP">
            <p>
              <span class="pubColorHeader">User ID</span>
              <span class="accountHeaderSpan">{{userData.userId}}</span>
            </p>
            <p>
              <span class="pubColorHeader">{{ $t('myAccount.header.email') }}</span>
              <span class="accountHeaderSpan">{{userData.email}}</span>
              <span @click="editPwdFunc()" class="editPasswordItem">{{ $t('myAccount.header.modify.pwd') }}</span>
            </p>
          </div>
        </div>
        <div>
          <div
            style="position:relative;;display:flex; width: 1080px;box-sizing: border-box;padding: 96px 0px 62px 90px;margin-top:30px;border:1px solid rgba(51, 51, 51, 0.2);"
          >
            <div style="position: absolute;right: 96px;top: 36px;">
              <div style="position:relative;">
                <button
                  class="storage"
                  @click="modifyFunc(modifyStored)"
                >
                <span>{{modifyStored ? $t('myAccount.form.button.save') : $t('myAccount.form.button.editor')}}</span>
                </button>
                <span class="storageLine"></span>
              </div>
            </div>
            <div style="margin-right: -55px">
              <div style>
                <h3>{{ $t('myAccount.form.info.basic') }}</h3>
                <div class="infoTableStyle">
                  <ul class="infoTableUl">
                    <li>
                      <p class="ulLiP">{{ $t('myAccount.form.basic.surname') }}</p>
                      <input
                        :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                        class="ulLiInput"
                        :readonly="modifyStored ? !modifyStored : !modifyStored "
                        type="text"
                        v-model="userData.lastName"
                      >
                    </li>
                    <li>
                      <p class="ulLiP">{{ $t('myAccount.form.basic.name') }}</p>
                      <input
                        :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                        class="ulLiInput"
                        :readonly="modifyStored ? !modifyStored : !modifyStored "
                        type="text"
                        v-model="userData.firstName"
                      >
                    </li>
                    <li>
                      <p class="ulLiP">{{ $t('myAccount.form.info.service') }}</p>
                      <input
                        :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                        class="ulLiInput"
                        :readonly="modifyStored ? !modifyStored : !modifyStored "
                        type="text"
                        v-model="userData.region"
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div style="margin-top:66px;">
                <h3>{{ $t('myAccount.form.info.service') }}</h3>
                <div class="infoTableStyle">
                  <ul class="colorHeaderUl">
                    <li>
                      <p class="ulLiP">{{ $t('myAccount.form.service.email') }}</p>
                      <input
                        :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                        class="ulLiInput"
                        :readonly="modifyStored ? !modifyStored : !modifyStored "
                        type="text"
                        v-model="userData.customerServiceMail"
                      >
                    </li>
                    <li>
                      <p class="ulLiP">{{ $t('myAccount.form.service.tel') }}</p>
                      <input
                        :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                        class="ulLiInput"
                        :readonly="modifyStored ? !modifyStored : !modifyStored "
                        type="text"
                        v-model="userData.customerServicePhone"
                      >
                    </li>
                    <li>
                      <p class="ulLiP">{{ $t('myAccount.form.service.website') }}</p>
                      <input
                        :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                        class="ulLiInput"
                        :readonly="modifyStored ? !modifyStored : !modifyStored "
                        type="text"
                        v-model="userData.customerServiceWeb"
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h3>{{ $t('myAccount.form.info.company') }}</h3>
              <div class="infoTableStyle">
                <ul class="infoTableUl">
                  <li>
                    <p class="ulLiP">{{ $t('myAccount.form.company.name') }}</p>
                    <input
                      :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                      class="ulLiInput"
                      :readonly="modifyStored ? !modifyStored : !modifyStored "
                      type="text"
                      v-model="userData.companyName"
                    >
                  </li>
                  <li>
                    <p class="ulLiP">{{ $t('myAccount.form.company.position') }}</p>
                    <input
                      :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                      class="ulLiInput"
                      :readonly="modifyStored ? !modifyStored : !modifyStored "
                      type="text"
                      v-model="userData.companyOccupation"
                    >
                  </li>
                  <li>
                    <p class="ulLiP">{{ $t('myAccount.form.company.website') }}</p>
                    <input
                      :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                      class="ulLiInput"
                      :readonly="modifyStored ? !modifyStored : !modifyStored "
                      type="text"
                      v-model="userData.companyWebsite"
                    >
                  </li>
                  <li>
                    <p class="ulLiP">{{ $t('myAccount.form.company.industry') }}</p>
                    <input
                      :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                      class="ulLiInput"
                      :readonly="modifyStored ? !modifyStored : !modifyStored "
                      type="text"
                      v-model="userData.companyIndustry"
                    >
                  </li>
                  <li>
                    <p class="ulLiP">{{ $t('myAccount.form.company.size') }}</p>
                    <input
                      :style="modifyStored ? 'border-color: rgba(51, 51, 51, 0.5);' : ''"
                      class="ulLiInput"
                      :readonly="modifyStored ? !modifyStored : !modifyStored "
                      type="text"
                      v-model="userData.companyScale"
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- editPassword -->
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" :close="closeDialog()">
          <el-form :model="form">
            <el-form-item label="原密码" :label-width="formLabelWidth">
              <el-input
                v-model="form.oldPwd"
                autocomplete="off"
                :type=" inputType.inputTypeOld ? 'password' : 'value' "
              ></el-input>
              <span @click="watchPwd('0')">查看原密码</span>
            </el-form-item>
            <el-form-item label="新密码" :label-width="formLabelWidth">
              <el-input
                v-model="form.newPwd"
                autocomplete="off"
                :type=" inputType.inputTypeNew ? 'password' : 'value' "
              ></el-input>
              <span @click="watchPwd('1')">查看新密码</span>
            </el-form-item>
            <el-form-item label="确认密码" :label-width="formLabelWidth">
              <el-input
                v-model="form.confirmPwd"
                autocomplete="off"
                :type=" inputType.inputTypeConfirm ? 'password' : 'value' "
              ></el-input>
              <span @click="watchPwd('2')">查看密码</span>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm()">确 定</el-button>
          </div>
        </el-dialog>
      </el-main>
    </div>
  </div>
</template>
<script>
export default {
    data () {
        return {
            elementItem: [
                { path: 'myAccount', msg: 'header.secondFloor.route.name.accountInfo' },
                true,
                { path: 'userRoles', msg: 'header.secondFloor.route.name.userPerm' },
                true,
                { path: 'financial', msg: 'header.secondFloor.route.name.financialManage' }
                // , true,
                // { path: 'planUpgrade', msg: 'header.secondFloor.route.name.developPlan' }
            ],
            iconNavTitle: '我的账户',
            userData: [],
            userDataClone: null,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            form: {
                oldPwd: '',
                newPwd: '',
                confirmPwd: ''
            },
            inputType: {
                inputTypeOld: true,
                inputTypeNew: true,
                inputTypeConfirm: true
            },
            errorMsg: null,
            modifyStored: false,
            userType: ''
        }
    },
    created () {
        // 账户 / 通知 header
        this.$store.state.iconNavHeader = this.elementItem
        // 请求user信息
        let path = 'developer/user/account/info'
        this._api
            .request('get', path)
            .then(response => {
                if (response.status === 200) {
                    this.userData = response.data.data.payload
                    this.userType = this.userData.type
                    this.userDataClone = Object.assign({}, this.userData)
                }
            })
            .catch(error => {
                console.log(error)
            })
    },
    methods: {
        docExportFunc () {
            this.getPdf('#app', 'myAccount')
        },
        updatePassword (inputPasseord, cb) {
            cb('loading')
            let id = this.userData.objectId
            let path = `/developer/user/account/${id}`
            let body = { password: inputPasseord }
            this._api
                .request('put', path, body)
                .then(response => {
                    if (response.status === 200) {
                        cb(true, response)
                    }
                })
                .catch(error => {
                    cb(false, error)
                    console.log(error)
                })
        },
        editPwdFunc () {
            let id = this.userData.objectId
            this.$router.push({
                path: '/user/account/updatePassword',
                query: {
                    id: id
                }
            })
        },
        submitForm () {
            let flag = Object.keys(this.form).every(
                item => this.form[item].indexOf(' ') === -1 && this.form[item] !== ''
            )
            if (!flag) {
                return
            }
            Object.keys(this.form).forEach((element, index) => {
                if (index === 1) {
                    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
                    let pwd = this.form[element]
                    if (reg.test(pwd)) {
                        if (pwd === this.form['confirmPwd']) {
                            this.errorMsg = null
                        } else {
                            this.errorMsg = '密码不同'
                        }
                    } else {
                        this.errorMsg = '密码不符合规定'
                    }
                }
            })
            if (this.errorMsg) {
                return
            }
            this.updatePassword(this.form.confirmPwd, this.submitCallBack)
        },
        closeDialog () {
            let form = this.form
            if (!this.dialogFormVisible) {
                Object.keys(this.form).forEach(element => {
                    form[element] = ''
                })
            }
        },
        submitCallBack (state, data) {
            if (state === 'loading') {
            } else if (state === 200) {
                this.dialogFormVisible = false
            }
        },
        watchPwd (type) {
            if (type === '0') {
                this.inputType.inputTypeOld = !this.inputType.inputTypeOld
            } else if (type === '1') {
                this.inputType.inputTypeNew = !this.inputType.inputTypeNew
            } else {
                this.inputType.inputTypeConfirm = !this.inputType.inputTypeConfirm
            }
        },
        modifyFunc (name) {
            this.modifyStored = !name
            if (!name) {
            } else {
                let data = {}
                Object.keys(this.userData).forEach(item => {
                    if (this.userData[item] !== this.userDataClone[item]) {
                        data[item] = this.userData[item]
                    }
                })
                this.modifyStoredFunc(data, this.submitCallBack)
            }
        },
        modifyStoredFunc (body, cb) {
            cb('loading')
            let id = this.userData.objectId
            let path = `/developer/user/account/${id}`
            this._api
                .request('put', path, body)
                .then(response => {
                    if (response.status === 200) {
                        cb(response.status)
                    }
                })
                .catch(error => {
                    cb(false, error)
                    console.log(error)
                })
        }
    }
}
</script>
<style scoped>
p {
  margin: 0;
  color: #333333;
}
li {
  list-style: none;
}
h3 {
  margin: 0px;
  display: inline-block;
  width: 348px;
  margin-bottom: 9px;
  width: 347px;
  height: 29px;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  color: #333333;
}
ul {
  padding: 0;
  margin: 0px;
}
.storage {
  width: 75px;
  height: 50px;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  text-align: center;
  color: #ffffff;
  outline: none;
  border: none;
  border-radius: 10px;
  background-color: #00b5e2;
  cursor: pointer;
  line-height: 50px;
  padding: 0px;
}
.storage > span{
  display: block;
  height: 100%;
  width: 100%;
}
.storage > span:hover{
  margin-top: -2px;
}
.storageLine {
  width: 55px;
  height: 2px;
  background: rgba(51, 51, 51, 0.3);
  position: absolute;
  left: 11px;
  bottom: 0px;
}

#myAccount {
  width: 1080px;
  margin: auto;
  margin-bottom: 100px;
}
.ulLiP {
  width: 348px;
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #333333;
  margin-bottom: 8px;
}
.ulLiInput {
  width: 348.3px;
  height: 38px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  outline: none;
  border: 1px solid rgba(51, 51, 51, 0.1);
  padding-left: 10px;
  box-sizing: border-box;
  margin-bottom: 18px;
}
.cooperation {
  display: block;
  padding: 3px 0px;
  width: 439px;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  color: #333333;
}
.cooperation:nth-child(1) {
  margin-right: 10px;
}
.accountHeaderP {
  margin-top: 25px;
  margin-bottom: 20px;
  justify-content: space-between;
  width: 800px;
}
.accountHeaderSpan {
  margin-left: 16px;
}
.editPasswordItem {
  display: inline-block;
  color: #00b5e2;
  margin-left: 8px;
  cursor: pointer;
}
.pubColorHeader {
  display: inline-block;
  width: 166px;
  opacity: 0.5;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  color: #333333;
  margin-bottom: 14px;
}
.colorHeaderUl {
  display: inline-block;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  color: #333333;
  margin-bottom: 14px;
}
.infoTableStyle {
  display: inline-flex;
}
.infoTableUl {
  margin-right: 108px;
  color: #d6d2d2;
}
.infoCompanyUl {
  margin-left: 50px;
  color: #333333cc;
}
</style>

<style>
#myAccount .el-main {
  padding: 0px;
}
</style>
